import {createSlice} from "@reduxjs/toolkit";
import camelize from "camelize";

const initialState = {
  error: null,
  idp: null,
  isComplete: false,
  loading: false,
  isLoggedIn: false,
  org: null,
  user: null
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authFlowStart: (state) => {
      state.loading = true;
    },
    authFlowComplete: () => {},
    authIdpLogin: () => {},
    authIdpLogout: () => {},
    authIdpLogoutSuccess: (state) => {
      state.loading = false;
      state.isLoggedIn = false;
    },
    authTokenRequested: () => {},
    authTokenReceived: () => {},
    authTokenFailed: (state) => {
      state.loading = false;
      state.isLoggedIn = false;
    },
    authCodeReceived: () => {},
    authUserRequested: (state) => {
      state.loading = true;
    },
    authUserReceived: (state, action) => {
      const me = camelize(action.payload);
      const {idp, org, user} = me;
      state.isComplete = true;
      state.loading = false;
      state.isLoggedIn = true;
      state.idp = idp;
      state.org = {
        ...org,
        activated: org.activationStatus === "activated"
      };
      state.user = user;
    },
    authUserFailed: (state, action) => {
      state.error = action.payload.error;
      state.loading = false;
      state.isLoggedIn = false;
    },
    authClearSession: (state) => {
      state.org = null;
      state.user = null;
    }
  }
});

export const {
  authFlowStart,
  authFlowComplete,
  authIdpLogin,
  /* authIdpLogout, */
  authIdpLogoutSuccess,
  authTokenRequested,
  authTokenReceived,
  authTokenFailed,
  authCodeReceived,
  authUserRequested,
  authUserReceived,
  authUserFailed,
  authClearSession
} = authSlice.actions;

export default authSlice.reducer;
